import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

// Customers and sizes run to thousands of terms. Filtering them is cheap but
// rendering them all is not, so only this many matches are shown at a time.
const MAX_VISIBLE = 75;

@Component({
  selector: 'app-term-select',
  templateUrl: './term-select.page.html',
  styleUrls: ['./term-select.page.scss'],
})
export class TermSelectPage implements OnInit {
  @Input() items: any[] = [];
  @Input() title = 'Select';
  @Input() selectedTid: any = null;

  search = '';
  visible: any[] = [];
  hidden = 0;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {
    this.filter();
  }

  filter() {
    const needle = (this.search || '').toLowerCase().trim();
    const matches = needle
      ? (this.items || []).filter(item => (item.name || '').toLowerCase().indexOf(needle) > -1)
      : (this.items || []);
    this.visible = matches.slice(0, MAX_VISIBLE);
    this.hidden = matches.length - this.visible.length;
  }

  choose(item) {
    this.modalCtrl.dismiss({ tid: item.tid, name: item.name });
  }

  clear() {
    this.modalCtrl.dismiss({ tid: null, name: '' });
  }

  cancel() {
    this.modalCtrl.dismiss();
  }

}
